// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1DLt8","label":"LabeledBox_label__22G2E"};